// extracted by mini-css-extract-plugin
module.exports = {"container":"container_3hPVl"};